import React from "react"
import Layout from "../../components/layout"
import Seo from "../../components/SEO/seo"
import { CenterTitle } from "../../components/titles/titles"
import MyTicket from "./ticket"

const Ticket = () => (
  <Layout location="Ticketing" title="Onai">
    <Seo title="Submit a ticket" />
    <div className="bg-neutralLighter">
      <div className="container  py-5">
        <CenterTitle subcolor="Simple "
                     title=" Ticket Submission"
                     subtitle="If you are an existing client submit any issues here for faster processing" />

        <p className="lead pb-4 text-center mx-auto col-md-6">Please fill in the problem you are
          having with as much detail as possible for a quick resolution.</p>

        <div className="row">
          <div className="col-md">
            <h5 className="text-danger">Don't do this</h5>
            <p>My website is not working.</p>
          </div>
          <div className="col-md">
            <h5 className="text-success">Do this</h5>
            <p>My website is crashing, it has not been responding since yesterday. I noticed it when i was creating a blog post.
              It has a message on the screen that says website unreachable.</p>
          </div>
        </div>
        <div className="row">
          <div className="col-md">
            <h5 className="text-danger">Don't do this</h5>
            <p>I cannot upload a product.</p>
          </div>
          <div className="col-md">
            <h5 className="text-success">Do this</h5>
            <p>Everytime I try to upload a product to my store, it keep loading in a loop until I refresh the whole web page.
              It's been happening since yesterday.
            </p>
          </div>
        </div>
        <MyTicket />
      </div>
    </div>


  </Layout>
)

export default Ticket
